import Image from "next/image";
import React from "react";

interface ChooseUsItemProps {
  icon: string;
  title: string;
  description: string;
}

export default function ChooseUsItem({ icon, title, description }: ChooseUsItemProps) {
  return (
     <div className="flex flex-col text-white items-center gap-2.5 w-[76.76vw] sm:w-[39vw] lg:w-[17.18vw]">
      <div className="relative w-mob-40 sm:w-tab-50 lg:w-web-55">
        <Image
          src={icon}
          alt={title}
          fill
          className="!static"
        />
      </div>
      <h3 className="text-mob-20 sm:text-tab-21 lg:text-web-24 leading-[130%] font-medium">{title}</h3>
      <p className="text-center text-mob-18 sm:text-tab-17 lg:text-web-20 font-normal leading-[135%]">{description}</p>
    </div>
  );
}
